// HeroSection.tsx
import { FC } from "react";
import { useTranslation } from "react-i18next";
import MouseScrollIndicator from "../../common/MouseScrollIndicator";

const HeroSection: FC<HeroSectionProps> = ({ setShowTermsModal }) => {
  const { t } = useTranslation();

  const handleSubmitTip = (e: any) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  return (
    <section className="relative flex flex-col justify-center items-center h-full text-white text-center pt-[40px] pb-[40px]">
      <h2 className="text-[40px] leading-[40px] font-[900] mb-[40px] max-w-[calc(100%-48px)] md:font-[800] md:text-[50px] md:mb-[48px] md:max-w-[80%] md:leading-[52px]">
        {t("welcome")}
      </h2>

      <div className="text-[14px] leading-[18px] font-[400] space-y-[18px] max-w-[calc(100%-48px)] sm:text-base sm:leading-[20px] md:max-w-[549px]">
        <p>{t("heroDescription1")}</p>
        <p>{t("heroDescription2")}</p>
      </div>

      <a
        href="/submit"
        onClick={handleSubmitTip}
        className="!no-underline text-base leading-[24px] font-[800] mt-[80px] bg-white text-gray-7 hover:text-gray-7 px-[72px] py-[15px] rounded-[24px] md:mt-[72px] md:text-[18px] md:leading-[22px]"
      >
        {t("submitTipBtn")}
      </a>

      <div className="absolute bottom-6 flex flex-col gap-2">
        <MouseScrollIndicator />
        {/* <p className="text-white text-[10px]">SCROLL DOWN</p> */}
      </div>
    </section>
  );
};

export default HeroSection;

interface HeroSectionProps {
  setShowTermsModal: (showTermsModal: boolean) => void;
}
